import React from "react";
import "../ui/ui.scss";

/**
 * ProgressBar — Thin animated progress indicator.
 *
 * Props:
 *   value     — 0-100 percentage
 *   size      — sm | md | lg  (height)
 *   color     — blue | emerald | violet | amber | rose
 *   className — Extra class
 */
const ProgressBar = ({ value = 0, size = "sm", color = "blue", className = "" }) => (
  <div className={`ui-progress ui-progress--${size} ${className}`}>
    <div
      className={`ui-progress__fill ui-progress__fill--${color}`}
      style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}
    />
  </div>
);

export default ProgressBar;
